import { css } from '@emotion/react'
import { colors, spacing, measures } from 'styles/variables'

const { unit } = measures

export const balanceContainer = css`
  padding: ${spacing(1, 4, 2, 4)};
  margin-bottom: ${spacing(0)};
`

export const sectionTitle = css`
  color: ${colors.white100};
  font-weight: 600;
`

export const mergedBalanceCard = css`
  background-color: ${colors.grays.gray8};
  border-radius: ${unit * 1.5}px;
  margin-bottom: ${spacing(1)};
  box-sizing: border-box;
  transition: all 0.3s ease;
  overflow: hidden;
`

export const currentBalanceSection = css`
  padding: ${spacing(3)};
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${colors.grays.gray7};
`

export const divider = css`
  height: 1px;
  background-color: rgba(255, 255, 255, 0.1);
  margin: 0;
`

export const topUpSection = css`
  width: 100%;
  padding: ${spacing(2.5)};
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease;
  text-align: left;

  &:hover {
    background-color: rgba(255, 255, 255, 0.05);
  }
`

export const balanceLabel = css`
  color: ${colors.white100};
  margin: 0;
  font-weight: 400;
`

export const balanceAmount = css`
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
  font-weight: 400;
`

export const topUpLabel = css`
  color: ${colors.white100};
  margin: 0;
  font-weight: 400;
`

export const arrowIcon = css`
  color: ${colors.white100};
  transition: transform 0.2s ease;

  ${topUpSection}:hover & {
    transform: translateX(2px);
  }
` 
